import api, { handleResponse, handleError } from './api';

/**
 * Blocking another person. The list only ever contains people YOU blocked —
 * the API never reveals who blocked you, which would defeat the point.
 */
const blockService = {
  async list() {
    try {
      return handleResponse(await api.get('/blocks'));
    } catch (error) {
      return handleError(error);
    }
  },

  async block(userId, reason = null) {
    try {
      return handleResponse(await api.post('/blocks', { userId, reason }));
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Report someone. Separate from blocking on purpose — "someone should look at
   * this" is a different ask from "I don't want to see them" — so the caller
   * decides whether to do both.
   */
  async report({ userId, reason, details, messageId = null, eventId = null, storyId = null, alsoBlock = false }) {
    try {
      return handleResponse(await api.post('/reports', {
        userId, reason, details, messageId, eventId, storyId, alsoBlock,
      }));
    } catch (error) {
      return handleError(error);
    }
  },

  async unblock(userId) {
    try {
      return handleResponse(await api.delete(`/blocks/${userId}`));
    } catch (error) {
      return handleError(error);
    }
  },
};

export default blockService;
